import { render, staticRenderFns } from "./subpackageProduct.vue?vue&type=template&id=160a1878&scoped=true&"
import script from "./subpackageProduct.vue?vue&type=script&lang=js&"
export * from "./subpackageProduct.vue?vue&type=script&lang=js&"
import style0 from "./subpackageProduct.vue?vue&type=style&index=0&id=160a1878&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a1878",
  null
  
)

export default component.exports